import Lottie from 'lottie-react'
import Confetti from 'shared/assets/lottie/Confetti.json'
import React from 'react'
import styled from 'styled-components'
import { media } from '../../../../assets/styles'

export const ConfettiDisplay = () => {
    return (
        <StyledContainer>
            <Lottie animationData={Confetti} loop={false} />
        </StyledContainer>
    )
}

const StyledContainer = styled.div`
    position: absolute;
    top: -200px;
    min-width: 500px;
    width: 500px;
    ${media.small`width:700px; top: -220px`}
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    pointer-events: none;
`
